import React, { useState } from "react";
import "./CleaningProcess.css";

const steps = [
  {
    title: "1. Schritt: Individuelle Analyse",
    content: "Individuelle Analyse Ihrer Anforderungen.",
  },
  {
    title: "2. Schritt: Vorbereitungsphase",
    content: "Wir planen den Ablauf im Detail.",
  },
  {
    title: "3. Schritt: Durchführungsphase",
    content: "Die Reinigung wird effizient umgesetzt.",
  },
  {
    title: "4. Schritt: Feedbacksystem",
    content: "Nachbereitung und Optimierung.",
  },
  { title: "Das Ergebnis", content: "Ein sauberes Ergebnis, das überzeugt." },
];

const CleaningProcess = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="process-section">
      <h2>
        Mit unserem Prozess stellen wir
        <br />
        Ihre Sauberkeit sicher!
      </h2>
      <div className="process-content">
        <div className="accordion">
          {steps.map((step, i) => (
            <div
              key={i}
              className={`accordion-item ${activeIndex === i ? "active" : ""}`}
            >
              <div className="accordion-header" onClick={() => toggle(i)}>
                {step.title} <span>{activeIndex === i ? "−" : "+"}</span>
              </div>
              {activeIndex === i && (
                <div className="accordion-body">{step.content}</div>
              )}
            </div>
          ))}
        </div>

        <div className="process-diagram">
          <div className="step-box">
            01
            <br />
            <span>Individuelle Analyse</span>
          </div>
          <div className="step-box">
            02
            <br />
            <span>Vorbereitungsphase</span>
          </div>
          <div className="step-box">
            03
            <br />
            <span>Durchführungsphase</span>
          </div>
          <div className="step-box">
            04
            <br />
            <span>Feedbacksystem</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CleaningProcess;
